// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3QF2-","description":"PatientConsentPreview_description__1QnYk"};